export default function ({ ...props }) {
    return (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6 12.6855C9.31371 12.6855 12 9.99926 12 6.68555C12 3.37184 9.31371 0.685547 6 0.685547C2.68629 0.685547 0 3.37184 0 6.68555C0 9.99926 2.68629 12.6855 6 12.6855ZM6.00016 5.51855C6.36835 5.51855 6.66683 5.74241 6.66683 6.01855V10.6852C6.66683 10.9614 6.36835 11.1852 6.00016 11.1852C5.63197 11.1852 5.3335 10.9614 5.3335 10.6852V6.01855C5.3335 5.74241 5.63197 5.51855 6.00016 5.51855ZM6.00016 2.85254C5.63197 2.85254 5.3335 3.15102 5.3335 3.51921C5.3335 3.8874 5.63197 4.18587 6.00016 4.18587H6.00683C6.37502 4.18587 6.6735 3.8874 6.6735 3.51921C6.6735 3.15102 6.37502 2.85254 6.00683 2.85254H6.00016Z"
                fill="#51351C"
                fillOpacity="0.5"
            />
        </svg>
    );
}
